import { NavLink, Link } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";

import { routes } from "../../../routes";
import logEcole229 from "../../../assets/images/logo-white.png";
import useAuth from "../../../hooks/useAuth";

export default function Sidebars({ dynamicWith, iconSize, collapsed }) {
  const { auth } = useAuth();

  const adminPermissions = [
    "gerer_candidatures",
    "gerer_admissions",
    "gerer_parcours",
    "gerer_sites_ou_campus_admission",
    "gerer_outils_tests_developpement_personnel",
    "gerer_utilisateurs_roles_permissions",
    "generer_rapports_statistiques_candidatures",
  ];

  const candidatePermissions = [
    "gerer_profil",
    "soumettre_candidature",
    "consulter_les_programmes",
    "suivre_l_etat_de_la_candidature",
    "acceder_aux_resultats",
    "passer_test_de_profil",
    "passer_test_de_developpement_personnel",
    "gerer_les_informations_personnelles",
  ];

  const juryPermissions = [
    "traiter_candidature",
    "donner_une_appreciation",
  ];
  return (
    <div
      className="sidebar"
      style={collapsed ? { width: "80px" } : { width: "250px" }}
    >
      <div className="sidebar__inner">
        <div className="sidebar__header">
          <div className="sidebar__logo">
            <Link
              to="/"
              className=""
              style={collapsed ? { paddingRight: 0, paddingLeft: 0 } : {}}
            >
              <img
                src={logEcole229}
                style={
                  collapsed
                    ? { objectFit: "contain", width: "50px", height: "45px" }
                    : {}
                }
              />
            </Link>
          </div>
        </div>
        <div className="sidebar__nav">
          <Sidebar collapsedWidth={"80px"} collapsed={collapsed}>
            <Menu
              menuItemStyles={{
                button: ({ level, active, disabled }) => {
                  // only apply styles on first level elements of the tree
                  if (level == 0)
                    return {
                      color: disabled ? "#f5d9ff" : active ? "#13395e" : "#fff",
                      backgroundColor: active ? "#fff" : "#143a7a",
                      "&:hover": {
                        color: "#143a7a",
                      },
                    };
                },
              }}
            >
              {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              ) && (
                <MenuItem
                  icon={<i className={routes.dashboard.statistic.icon}></i>}
                  component={<Link to={routes.dashboard.statistic.path} />}
                >
                  Statisques
                </MenuItem>
              )}

              {/* <MenuItem
                icon={<i className="pi pi-list"></i>}
                component={<Link to={routes.dashboard.profil.path} />}
              >
                Mon Profil
              </MenuItem> */}
              {auth?.permissions?.find((permission) =>
                candidatePermissions.includes(permission?.name)
              ) && (
                <MenuItem
                  icon={<i className="pi pi-briefcase"></i>}
                  component={<Link to={routes.dashboard.mycandidates.path} />}
                >
                  Mes Candidatures
                </MenuItem>
              )}
              {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              ) && (
                <SubMenu
                  label="Administrations"
                  icon={<i className={routes.dashboard.branches.icon}></i>}
                >
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={<Link to={routes.dashboard.branches.path} />}
                  >
                    Sites
                  </MenuItem>
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={<Link to={routes.dashboard.trainings.path} />}
                  >
                    Parcours
                  </MenuItem>
                </SubMenu>
              )}
              {auth?.permissions?.find((permission) =>
                juryPermissions.includes(permission?.name)
              ) && (
                <SubMenu
                  label="Candidatures"
                  icon={<i className={routes.dashboard.candidates.icon}></i>}
                >
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={<Link to={routes.dashboard.candidates.path} />}
                  >
                    Actif
                  </MenuItem>
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={
                      <Link to={routes.dashboard.candidateArchives.path} />
                    }
                  >
                    Archives
                  </MenuItem>
                </SubMenu>
              )}
              {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              ) && (
                <SubMenu
                  label="Parametrage"
                  icon={<i className="pi pi-table"></i>}
                >
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={<Link to={routes.dashboard.requirement.path} />}
                  >
                    Pré-requis
                  </MenuItem>
                  <MenuItem
                    icon={<i className="pi pi-list"></i>}
                    component={<Link to={routes.dashboard.generalTest.path} />}
                  >
                    Test de Développement Personnel
                  </MenuItem>
                </SubMenu>
              )}
              {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              ) && (
                <SubMenu
                  label="Attributions"
                  icon={<i className={routes.dashboard.setting.icon}></i>}
                >
                  <MenuItem
                    icon={<i className={routes.dashboard.role.icon}></i>}
                    component={<Link to={routes.dashboard.role.path} />}
                  >
                    {" "}
                    Roles{" "}
                  </MenuItem>
                  <MenuItem
                    icon={<i className={routes.dashboard.permission.icon}></i>}
                    component={<Link to={routes.dashboard.permission.path} />}
                  >
                    {" "}
                    Permissions{" "}
                  </MenuItem>
                </SubMenu>
              )}
              {auth?.permissions?.find((permission) =>
                adminPermissions.includes(permission?.name)
              ) && (
                <MenuItem
                  icon={<i className="pi pi-users"></i>}
                  component={<Link to={routes.dashboard.users.path} />}
                >
                  Utilisateurs
                </MenuItem>
              )}
            </Menu>
          </Sidebar>
        </div>
      </div>
    </div>
  );
}
